module.exports = __webpack_public_path__ + "assets/media/grafitti-texture.444e6598.svg";